import { apiClient } from "api/ApiClient";

/**
 * 予約一覧取得
 */
const signin = async (signin_id: string, password: string): Promise<any> => {
    try {
        const response = await apiClient.post(`/signin`, {
            signInId: signin_id,
            password: password,
        });
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

export const SigninApi = {
    signin,
};
